/* eslint-disable no-case-declarations */
import parse from 'html-react-parser';
import React, { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import Image from '../image';
import { data } from './assets/export.assests';
import { Container, Hr } from './styles';
import componentRenderer from '../component-renderer';

type IProjectBox = {
  componentType:
    | 'secaoExperimentoteca'
    | 'secaoMaosNaMatematica'
    | 'secaoRodaGigante';
  object: string;
};

type TWraper = {
  children: string | ReactNode;
};

const MemoizedWraperContent = React.memo(({ children }: TWraper) => (
  <>{typeof children === 'string' ? parse(children) : children}</>
));

function ProjectBox({ componentType, object }: IProjectBox) {
  const { materia } = useParams();

  if (!materia) return <>Componente didático em desenvolvimento</>;

  const getImageByKey = (name: string) => {
    if (data.hasOwnProperty(name)) {
      return data[name];
    } else {
      return '';
    }
  };

  const parser = new DOMParser();
  const doc = parser.parseFromString(object, 'text/html');

  const lesson = doc.querySelector(
    '.secaoExperimentoteca tbody tr:nth-child(2) > td, .secaoMaosNaMatematica tbody tr:nth-child(2) > td, .secaoRodaGigante tbody tr:nth-child(2) > td'
  );

  let childrenArray: any[] = [];

  if (lesson) {
    childrenArray = Array.from(lesson.children);
  }

  return (
    <Container>
      <Image
        src={getImageByKey(componentType)}
        texto_alternativo={`Imagem do logo de ${componentType}`}
        newClassName="logoImage"
      />
      <Hr $subject={materia} />
      <MemoizedWraperContent>
        {childrenArray.map((child) => componentRenderer(child))}
      </MemoizedWraperContent>
      <Hr $subject={materia} />
    </Container>
  );
}

export default ProjectBox;
